
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bGrkd", function(module, exports) {
$parcel$export(module.exports, "JoinableSites", function () { return $701300cad08ca63f$export$fa96b097075fdf52; });
/* joinable-sites.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kNE9Z = parcelRequire("kNE9Z");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $7GVWk = parcelRequire("7GVWk");

var $9tcM4 = parcelRequire("9tcM4");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $ff4S3 = parcelRequire("ff4S3");

var $jgBbG = parcelRequire("jgBbG");
const $701300cad08ca63f$export$fa96b097075fdf52 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}) })=>{
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(false);
    const { product: product, edition: edition, profile: profile } = (0, $7GVWk.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const { user: { email: email } } = (0, $7GVWk.useUserContext)();
    const { productName: productName } = (0, $fcO7r.getProductData)(product?.key);
    let sites = profile.attributes?.existingProductsFromOrg.filter(({ accessType: accessType })=>[
            (0, $9tcM4.AccessRequestCapability).DIRECT_ACCESS,
            (0, $9tcM4.AccessRequestCapability).REQUEST_ACCESS
        ].includes(accessType)).sort((a, b)=>a.accessType !== b.accessType && a.accessType === (0, $9tcM4.AccessRequestCapability).DIRECT_ACCESS ? -1 : 1) || [];
    // make sure sites are unique by cloudId (userProfile can return duplicates)
    sites = Array.from(sites.reduce((acc, currentItem)=>{
        if (!acc.has(currentItem.cloudId)) acc.set(currentItem.cloudId, currentItem);
        return acc;
    }, new Map()).values());
    const requestAccess = intl.formatMessage({
        id: "signup.siteActivation.requestAccess",
        defaultMessage: "Request access"
    });
    const join = intl.formatMessage({
        id: "signup.siteActivation.join",
        defaultMessage: "Join"
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>$701300cad08ca63f$var$createNewWorkspaceMessageLink(str, ()=>{
                setShowSiteNaming(true);
                createAnalyticsEvent({
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "joinableSitesGoToSiteNamingScreen",
                    attributes: {
                        productName: product?.name,
                        productKey: product?.key,
                        edition: edition
                    }
                }).fire();
            })
    };
    const createNewWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "joinableSitesGoToReturnToProductScreen",
            attributes: {
                productName: product?.name,
                productKey: product?.key,
                edition: edition
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$701300cad08ca63f$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            ExistingUser,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $701300cad08ca63f$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "return-to-product",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp7vkz _1jop70sv _1bv01wug"
                ]),
                children: sites?.map((site, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                        href: $701300cad08ca63f$var$getProductUrl(site),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: site.accessType === (0, $9tcM4.AccessRequestCapability).REQUEST_ACCESS ? "joinableSitesClickRequestAccessButton" : "joinableSitesClickJoinSiteButton",
                                attributes: {
                                    productName: productName,
                                    productKey: site.productKey,
                                    edition: site.productEdition
                                }
                            }).fire();
                            window.location.assign($701300cad08ca63f$var$getProductUrl(site));
                        },
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _zulp19bv _yv0e1ghl _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                        ]),
                        style: {
                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb7vkz _1reo15vq _18m915vq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: productName
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1hap _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                        ]),
                                        style: {
                                            "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                        },
                                        children: site.displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1sg8jdj5 _1o7pdlk8 _187zmgvx _1wtnftgi"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    children: site.accessType === (0, $9tcM4.AccessRequestCapability).REQUEST_ACCESS ? requestAccess : join
                                })
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $701300cad08ca63f$var$getProductUrl = ({ productKey: productKey, productUrl: productUrl })=>{
    // jira links should be myjira.atlassian.net/welcome/software
    if (productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE) {
        const { origin: origin } = new URL(productUrl);
        productUrl = `${origin}/welcome/software`;
    }
    //send to identity login with continue param
    const joinUrl = new URL("/login", (0, $kNE9Z.getIdentityBaseUrl)());
    joinUrl.searchParams.append("continue", productUrl);
    return joinUrl.toString();
};
const $701300cad08ca63f$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l33gnd"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $701300cad08ca63f$var$createNewWorkspaceMessageLink = (str, exitView)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: exitView,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $701300cad08ca63f$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $gZgIU.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $701300cad08ca63f$var$containerCss = null;
const $701300cad08ca63f$var$goToExistingWorkspaceLinkCss = null;
const $701300cad08ca63f$var$goToExistingWorkspaceMessageCss = null;
const $701300cad08ca63f$var$switchAccountSubheader = null;
const $701300cad08ca63f$var$createNewWorkspaceMessageCss = null;
const $701300cad08ca63f$var$createNewWorkspaceLinkCss = null;
const $701300cad08ca63f$var$boxContainerCss = null;
const $701300cad08ca63f$var$siteBoxCss = null;
const $701300cad08ca63f$var$goToProductButtonCss = null;
const $701300cad08ca63f$var$bold = null;
const $701300cad08ca63f$var$siteCss = null;
const $701300cad08ca63f$var$siteNameCss = null;
const $701300cad08ca63f$var$emailCss = null;
const $701300cad08ca63f$var$switchAccountLinkCss = null;

});
parcelRegister("ff4S3", function(module, exports) {
$parcel$export(module.exports, "useSiteActivationContext", function () { return $d9523cfc95d5074c$export$48473054405e7add; });
$parcel$export(module.exports, "SiteActivationContextProvider", function () { return $d9523cfc95d5074c$export$e1087d57f38afae1; });
//TO DO: in the next PR refactor and test this context

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eLTTO = parcelRequire("eLTTO");

var $8e22h = parcelRequire("8e22h");

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");

var $iSeHD = parcelRequire("iSeHD");

var $buVH1 = parcelRequire("buVH1");

var $cG7vk = parcelRequire("cG7vk");

var $36RSw = parcelRequire("36RSw");

var $9EuLB = parcelRequire("9EuLB");

var $fcO7r = parcelRequire("fcO7r");

var $427NR = parcelRequire("427NR");

var $77cxG = parcelRequire("77cxG");

var $6isYE = parcelRequire("6isYE");

var $fgra6 = parcelRequire("fgra6");

var $gPKCY = parcelRequire("gPKCY");

var $lIWv2 = parcelRequire("lIWv2");

var $gZgIU = parcelRequire("gZgIU");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");

var $9tcM4 = parcelRequire("9tcM4");

var $jQ0cd = parcelRequire("jQ0cd");

var $gx3aw = parcelRequire("gx3aw");

var $1ka2O = parcelRequire("1ka2O");

var $cURcB = parcelRequire("cURcB");

var $amfpH = parcelRequire("amfpH");
const { ABORTED: $d9523cfc95d5074c$var$ABORTED, SUCCEEDED: $d9523cfc95d5074c$var$SUCCEEDED } = (0, $lIWv2.UfoExperienceStatus);
const { PRESS: $d9523cfc95d5074c$var$PRESS, TRANSITION: $d9523cfc95d5074c$var$TRANSITION } = (0, $lIWv2.UfoInteractionType);
const $d9523cfc95d5074c$var$ufoBaseLogs = [
    {
        name: "pkg:site-activation"
    },
    {
        name: "component:siteActivationContextProvider"
    }
];
const $d9523cfc95d5074c$export$fe5d808150ab3415 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $d9523cfc95d5074c$export$48473054405e7add = ()=>{
    const context = (0, $1oC0p.useContext)($d9523cfc95d5074c$export$fe5d808150ab3415);
    if (!context) throw new Error("useSiteActivationContext must be used within a SiteActivationContextProvider");
    return context;
};
async function $d9523cfc95d5074c$var$getHasHighestEditionStrategyWithPaidTargetEdition({ cloudId: cloudId, productKey: productKey, stargateClient: stargateClient, signupSource: signupSource, createAnalyticsEvent: createAnalyticsEvent }) {
    if (!cloudId || !productKey || signupSource === "pricing" || ![
        (0, $fcO7r.ProductKey).CONFLUENCE,
        (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
        (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY,
        (0, $fcO7r.ProductKey).JIRA_SERVICE_DESK,
        (0, $fcO7r.ProductKey).SERVICE_COLLECTION
    ].includes(productKey)) return false;
    try {
        (0, $buVH1.trackCrossFlowActivationPlanFetched)({
            createAnalyticsEvent: createAnalyticsEvent,
            cloudId: cloudId,
            productKey: productKey
        });
        const activateProductCrossflowPlanResult = await stargateClient.activateProductCrossflowPlan({
            cloudId: cloudId,
            productKey: productKey,
            jobName: (0, $9tcM4.JobName).WAC_SIGNUP,
            context: {
                sourceComponent: "redirect",
                sourceContext: "start",
                originProduct: "wac"
            }
        });
        const activatePlanTaskContext = activateProductCrossflowPlanResult?.tasks?.find((task)=>task?.name === "activate")?.context;
        return activatePlanTaskContext?.["editionStrategy"] === "highest" && activatePlanTaskContext?.["edition"]?.["id"] !== "free";
    } catch (error) {
        (0, $buVH1.trackCrossFlowActivationPlanFailed)({
            createAnalyticsEvent: createAnalyticsEvent,
            cloudId: cloudId,
            productKey: productKey,
            error: error
        });
        return false;
    }
}
const $d9523cfc95d5074c$export$e1087d57f38afae1 = ({ children: children, existingSites: existingSites, useContactExpandCohortLogic: useContactExpandCohortLogic })=>{
    //HOOKS
    const intl = (0, $8e22h.default)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eLTTO.useGoogleReCaptcha)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { profile: profile, user: user, product: product, edition: originalEdition = "free", transactionAccounts: transactionAccounts } = (0, $7GVWk.useUserContext)();
    /**
   * Rovo Dev (aka DEVAI) is a special case, it only has a single
   * edition, standard. There is an outstanding DACI:
   * https://hello.atlassian.net/wiki/spaces/uts/pages/5807772710/Rovo+Dev+Everywhere+SKU+DACI
   * If/when this DACI is resolved and Rovo Dev supports the free
   * edition, this special case can then be removed.
   */ let edition = originalEdition;
    if (product?.key === (0, $fcO7r.ProductKey).DEVAI) edition = "standard";
    const { companyType: companyType, domainType: domainType, userType: userType } = profile?.cohorts || {};
    const cohort = (0, $2WL8B.useCohort)(useContactExpandCohortLogic);
    const expandableSites = (0, $2WL8B.useCrossflowEligibleSites)();
    const upgradableSites = (0, $2WL8B.useUpgradableSites)();
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const location = (0, $1ka2O.useLocation)();
    const sites = (0, $1oC0p.useMemo)(()=>existingSites ?? (cohort === (0, $2WL8B.COHORTS).UPGRADE_ELIGIBLE_USER ? upgradableSites : expandableSites) ?? [], [
        cohort,
        expandableSites,
        upgradableSites,
        existingSites
    ]);
    const isWorkspaceProduct = (0, $1oC0p.useMemo)(()=>!!product?.key && [
            (0, $fcO7r.ProductKey).CONFLUENCE,
            (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION,
            (0, $fcO7r.ProductKey).SERVICE_COLLECTION
        ].includes(product?.key), [
        product?.key
    ]);
    //STATE
    const [showSitePicker, setShowSitePicker] = (0, $1oC0p.useState)(sites.length > 0);
    const [siteNameValid, setSiteNameValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [sitePickerValue, setSitePickerValue] = (0, $1oC0p.useState)(sites[0]);
    const [siteName, setSiteNameValue] = (0, $1oC0p.useState)("");
    const [recommendedSiteName] = (0, $1oC0p.useState)("");
    const [selectedTransactionAccountId, setSelectedTransactionAccountId] = (0, $1oC0p.useState)(transactionAccounts[0]?.id ?? "");
    const [recaptchaFailedToLoad, setRecaptchFailedToLoad] = (0, $1oC0p.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $1oC0p.useState)(60);
    const [validatationMessage, setValidationMessage] = (0, $1oC0p.useState)();
    const [paymentDetailsView, setPaymentDetailsView] = (0, $1oC0p.useState)({
        view: "site-setup"
    });
    //VARIABLES
    const searchParameters = new URLSearchParams(location.search);
    const platform = searchParameters.get("platform") ?? "routing";
    const primaryCollectionProduct = searchParameters.get("primaryCollectionProduct");
    const localizedContactUrl = (0, $jQ0cd.useLocalizedHref)("/company/contact");
    const isNewUser = profile.cohorts?.userType === "new-user";
    const productKey = product?.key;
    const { isValid: isValid, isValidating: isValidating, error: error } = (0, $cURcB.useSiteNameValidation)(siteName, setSiteNameValid);
    const isEmbedded = !location.pathname?.endsWith("/try/cloud/signup");
    const dataFoundationsActionSubjectId = isEmbedded ? "embedded" : "standalone";
    const showRecaptchaFormError = (0, $1oC0p.useCallback)(()=>{
        const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "n/a");
        setValidationMessage({
            ...(0, $amfpH.messages).timeout,
            values: {
                // eslint-disable-next-line react/no-unstable-nested-components
                "href-support": (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        href: localizedContactUrl,
                        children: node
                    }),
                "error_id": `Anonymous ID: ${anonymousId}`
            }
        });
        // Reset form to allow re-submit
        setIsSubmitting(false);
        setHasSubmitted(false);
    }, [
        localizedContactUrl
    ]);
    const activateSiteHandler = (0, $1oC0p.useCallback)(async (signupId, privacyPolicy)=>{
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setRecaptchFailedToLoad(true);
            return;
        }
        setRecaptchFailedToLoad(false);
        const localeData = await stargateClient.getConsentConfig();
        const testingPurposes = (0, $9EuLB.isTestTenantByName)(siteName);
        const signupContext = (0, $36RSw.getSignupContext)({
            productKey: productKey,
            testingPurposes: testingPurposes,
            signupId: signupId,
            search: location.search,
            locale: intl.locale
        });
        const MAX_SIGNUP_CONTEXT_LENGTH = 8192;
        let signupContextString = JSON.stringify(signupContext);
        if (signupContextString.length > MAX_SIGNUP_CONTEXT_LENGTH) signupContextString = "{}";
        const ccpProducts = (0, $fcO7r.mapProductKeyAndEditionToCcpProduct)({
            productKey: productKey,
            edition: edition,
            primaryCollectionProduct: primaryCollectionProduct
        });
        const gRecaptchaResponse = await (0, $427NR.getRecaptcha)(user["email"] || "", executeRecaptcha);
        (0, $gPKCY.ufoEventNewSiteN2NSubmit).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse ?? "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "SiteActivationProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $buVH1.trackRecaptchaFailure)(createAnalyticsEvent, "site-activation");
            showRecaptchaFormError();
            return;
        }
        // Set experiment metadata before starting UFO event for GraphQL webhook setup
        (0, $gPKCY.ufoEventGraphQLWebhookSetup).setCustomData({
            webPlatform: "site-activation"
        });
        // get consents
        const consent = (0, $cG7vk.getConsents)(localeData.locale ?? "US-VA", localeData.localeRequiresMarketingCommunicationOptIn, privacyPolicy);
        const response = await stargateClient.activateProduct({
            displayName: user["name"],
            email: user["email"] || "",
            ccpProducts: [
                ccpProducts
            ],
            siteName: siteName,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            useCcpPlatform: platform === "ccp",
            consent: consent,
            platform: platform,
            signupContext: signupContextString,
            isNewUser: productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE || isNewUser,
            gRecaptchaResponse: gRecaptchaResponse,
            testingPurposes: testingPurposes,
            signupId: signupId,
            transactionAccountId: selectedTransactionAccountId
        });
        const redirectUrl = (0, $gZgIU.getConfirmationPageUrl)({
            locale: intl.locale,
            productKey: productKey,
            response: response,
            siteName: siteName,
            signupId: signupId,
            edition: edition,
            primaryCollectionProduct: primaryCollectionProduct
        });
        window.location.assign(redirectUrl);
    }, [
        executeRecaptcha,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        stargateClient,
        siteName,
        primaryCollectionProduct,
        location.search,
        productKey,
        edition,
        user,
        platform,
        isNewUser,
        intl.locale,
        createAnalyticsEvent,
        selectedTransactionAccountId
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (profile.requestInProgress || !analyticsClient) return;
        (0, $buVH1.trackSiteActivationViewed)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            cohort: cohort,
            productKey: productKey,
            edition: edition,
            userType: userType,
            domainType: domainType,
            companyType: companyType,
            numTxas: transactionAccounts.length
        });
    }, [
        analyticsClient,
        cohort,
        createAnalyticsEvent,
        companyType,
        dataFoundationsActionSubjectId,
        domainType,
        edition,
        productKey,
        profile.requestInProgress,
        userType,
        transactionAccounts.length
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const ufoSubmitEvent = showSitePicker ? (0, $gPKCY.ufoEventExistingSiteN2ESubmit) : (0, $gPKCY.ufoEventNewSiteN2NSubmit);
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) ufoSubmitEvent.failure({
            customData: {
                reactComponent: "SiteActivationContextProvider",
                analyticsEvent: "errored",
                recaptchaRetryTimeRemainingSecond: 0,
                siteType: showSitePicker ? "existing-site" : "new-site"
            },
            error: new Error("Recaptcha retry failed")
        });
        if (recaptchaFailedToLoad) activateSiteHandler().then(()=>{
            ufoSubmitEvent.success({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "succeeded",
                    siteType: showSitePicker ? "existing-site" : "new-site",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            showRecaptchaFormError();
            ufoSubmitEvent.failure({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "errored",
                    siteType: showSitePicker ? "existing-site" : "new-site",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        });
    }, [
        activateSiteHandler,
        executeRecaptcha,
        localizedContactUrl,
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        showSitePicker
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    const activateSite = async ({ privacyPolicy: privacyPolicy })=>{
        setHasSubmitted(true);
        sessionStorage.setItem("provisioningStartTime", `${Date.now()}`);
        // Start UFOs to begin duration metrics for signup submit
        (0, $gPKCY.ufoEventNewSiteN2NSubmit).start({
            productKey: productKey,
            webPlatform: "site-activation"
        });
        (0, $gPKCY.ufoEventExistingSiteN2ESubmit).start({
            productKey: productKey,
            webPlatform: "site-activation"
        });
        const ufoLogs = [
            ...$d9523cfc95d5074c$var$ufoBaseLogs,
            {
                name: "method:activateSite"
            }
        ];
        // user must be logged in
        if (!user.isUserLoggedIn) return;
        // Generate a signup ID and add it to all the events in this flow.
        // This id is used to stitch together a view of the end-to-end
        // provisioning experience, all the way to landing in product.
        const signupId = (0, $fuLgT.default)();
        const isN2N = !showSitePicker && !sitePickerValue;
        const domainType = profile?.cohorts?.domainType;
        (0, $buVH1.trackSignupStarted)(createAnalyticsEvent, signupId, productKey, edition, isN2N, domainType);
        // handle site picker submit
        if (showSitePicker) {
            if (sitePickerValue) {
                const upgradableProduct = sitePickerValue.products.find((product)=>[
                        product.productKey,
                        product.partOfCollection
                    ].includes(productKey) && product.productEdition === "free");
                // checking the standard-to-premium upgrade eligibility cohort
                const hasUpgradableStandardProduct = edition === "premium" && [
                    (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
                    (0, $fcO7r.ProductKey).CONFLUENCE,
                    (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY
                ].includes(productKey) && sitePickerValue.products.some((product)=>[
                        product.productKey
                    ].includes(productKey) && product.productEdition === "standard");
                if (upgradableProduct || hasUpgradableStandardProduct) {
                    // send to adminhub
                    const redirectUrl = await (0, $gZgIU.getAdminHubUpgradeProductUrl)(sitePickerValue, productKey, edition);
                    createAnalyticsEvent({
                        eventName: "signupUpgrade",
                        eventComponent: "button",
                        billingSystem: sitePickerValue.products[0]?.billingSourceSystem,
                        cloudId: sitePickerValue.cloudId,
                        event: "clicked",
                        eventType: "ui",
                        action: "upgrade"
                    }).fire("signup");
                    window.location.assign(redirectUrl);
                    return;
                }
                try {
                    // Check for Shadow IT authorization.
                    await stargateClient.getActivationAuthorization({
                        productKeys: [
                            productKey
                        ],
                        productEdition: edition,
                        cloudId: sitePickerValue.cloudId,
                        siteName: sitePickerValue?.displayName
                    });
                    const searchParameters = new URLSearchParams(window.location.search);
                    const signupSource = searchParameters.get("signupSource");
                    // fetch /plans endpoint once user has clicked
                    const hasHighestEditionStrategyWithPaidTargetEdition = await $d9523cfc95d5074c$var$getHasHighestEditionStrategyWithPaidTargetEdition({
                        cloudId: sitePickerValue.cloudId,
                        productKey: productKey,
                        stargateClient: stargateClient,
                        signupSource: signupSource,
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                    const crossFlowActivationUrl = (0, $gZgIU.getCrossFlowActivationUrl)({
                        cloudId: sitePickerValue.cloudId,
                        edition: edition,
                        productKey: primaryCollectionProduct ?? productKey,
                        siteName: sitePickerValue?.displayName,
                        hasHighestEditionStrategyWithPaidTargetEdition: hasHighestEditionStrategyWithPaidTargetEdition
                    });
                    (0, $gPKCY.ufoEventExistingSiteN2ESubmit).success({
                        customData: {
                            reactComponent: "SiteActivationContextProvider",
                            analyticsEvent: "succeeded",
                            siteType: "existing-site"
                        }
                    });
                    (0, $buVH1.trackSitePickerSubmit)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        targetCloudId: sitePickerValue.cloudId,
                        provisionedProducts: [
                            {
                                product: productKey,
                                edition: edition
                            }
                        ],
                        signupUrl: crossFlowActivationUrl,
                        aaid: user["accountId"],
                        signupSource: signupSource,
                        componentSource: "SiteActivationContextProvider",
                        hasHighestEditionStrategyWithPaidTargetEdition: hasHighestEditionStrategyWithPaidTargetEdition
                    });
                    window.location.assign(crossFlowActivationUrl);
                } catch (error) {
                    (0, $gPKCY.ufoEventExistingSiteN2ESubmit).failure({
                        customData: {
                            reactComponent: "SiteActivationContextProvider",
                            analyticsEvent: "errored",
                            siteType: "existing-site"
                        },
                        error: error
                    });
                    (0, $77cxG.redirectToAdminHubForShadowIt)(error);
                }
            }
            return;
        }
        if (isValidating) {
            const { availability: availability } = await stargateClient.checkCloudNameAvailability({
                cloudName: siteName
            });
            if (availability !== "AVAILABLE") {
                setHasSubmitted(false); // reset to allow re-submit
                return;
            }
            setSiteNameValid(true);
        }
        if (!siteNameValid && !isValidating || !siteName) {
            setHasSubmitted(false); // reset to allow re-submit
            return;
        }
        (0, $buVH1.trackSubmitSuccess)(createAnalyticsEvent);
        if (siteName !== recommendedSiteName) (0, $buVH1.trackSiteNameChangedFromRecommendedSiteName)(createAnalyticsEvent, siteName, recommendedSiteName);
        let setTimeoutId;
        const interactionId = (0, $fuLgT.default)();
        (0, $fgra6.operateWithSignupUFOLogging)({
            interactionId: interactionId,
            interactionName: "try-cloud-signup_form-submit",
            type: "press",
            timeout: 120000,
            labelStack: [
                {
                    name: "uip"
                }
            ],
            errorContext: "error occured on signup form submit button"
        }, async ()=>Promise.race([
                new Promise((_resolve, reject)=>{
                    setTimeoutId = setTimeout(()=>{
                        reject((0, $fgra6.SignupUFOLoggingActionTimeoutError));
                    }, 60000);
                }),
                activateSiteHandler(signupId, privacyPolicy).finally(()=>{
                    if (setTimeoutId) clearTimeout(setTimeoutId);
                })
            ])).then(()=>{
            // SLO "good event" for N2N signup submit
            (0, $gPKCY.ufoEventNewSiteN2NSubmit).success({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "succeeded",
                    siteType: "new-site"
                }
            });
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).ACTIVATE_PRODUCT_API_SUCCESS,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$TRANSITION,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured on bxp-ui only
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured across bxp-ui and bxpkit
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                ufoLogger: ufoLogs
            });
        }).catch((error)=>{
            // Show add-payment-method page if Rovo Dev 403 (user clicks "Open payment methods" to open in new tab)
            if (productKey === (0, $fcO7r.ProductKey).DEVAI && error?.response?.status === 403) {
                const adminPaymentLink = (0, $6isYE.getAdminPaymentLink)(error);
                if (adminPaymentLink) {
                    setIsSubmitting(false);
                    setHasSubmitted(false);
                    setPaymentDetailsView({
                        view: "payment-required",
                        adminPaymentLink: adminPaymentLink
                    });
                    return;
                }
            }
            // SLO "bad event" for N2N signup submit
            (0, $gPKCY.ufoEventNewSiteN2NSubmit).failure({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "errored",
                    siteType: "new-site"
                },
                error: error
            });
            (0, $77cxG.redirectToAdminHubForShadowIt)(error);
            const traceId = error?.response?.headers?.get("atl-traceid");
            setValidationMessage({
                ...(0, $amfpH.messages).timeout,
                values: {
                    // eslint-disable-next-line react/no-unstable-nested-components
                    "href-support": (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: localizedContactUrl,
                            children: node
                        }),
                    "error_id": traceId ? `Trace ID: ${traceId}` : `Interaction ID: ${interactionId}`
                }
            });
            // don't re-enable the form when there is an HTTP exception. this helps with rate-limiting
            const errorType = (0, $fgra6.SignupGetUFOErrorType)(error);
            if (errorType !== "http_exception") {
                // Reset form to allow re-submit
                setIsSubmitting(false);
                setHasSubmitted(false);
            }
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).ACTIVATE_PRODUCT_API_ERROR,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$TRANSITION,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured on bxp-ui only
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured across bxp-ui and bxpkit
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d9523cfc95d5074c$export$fe5d808150ab3415.Provider, {
        value: {
            isSubmitting: isSubmitting,
            activateSite: activateSite,
            showSitePicker: showSitePicker,
            sites: sites,
            isRequestInProgress: profile.requestInProgress,
            email: user["email"],
            sitePickerValue: sitePickerValue,
            setSitePickerValue: setSitePickerValue,
            setSiteNameValid: setSiteNameValid,
            siteName: siteName,
            setSiteNameValue: setSiteNameValue,
            setShowSitePicker: setShowSitePicker,
            recommendedSiteName: recommendedSiteName,
            hasSubmitted: hasSubmitted,
            setHasSubmitted: setHasSubmitted,
            validationMessageState: [
                validatationMessage,
                setValidationMessage
            ],
            isValid: isValid,
            isValidating: isValidating,
            error: error,
            isWorkspaceProduct: isWorkspaceProduct,
            selectedTransactionAccountId: selectedTransactionAccountId,
            setSelectedTransactionAccountId: setSelectedTransactionAccountId,
            primaryCollectionProduct: primaryCollectionProduct,
            paymentDetailsView: paymentDetailsView,
            setPaymentDetailsView: setPaymentDetailsView
        },
        children: children
    });
};

});
parcelRegister("77cxG", function(module, exports) {
$parcel$export(module.exports, "redirectToAdminHubForShadowIt", function () { return $03ca8126a2fae79c$export$cf3cb68c5cf1d1dd; });

var $eMftW = parcelRequire("eMftW");
const $03ca8126a2fae79c$export$cf3cb68c5cf1d1dd = (error)=>{
    const errorCode = error?.response?.status;
    const redirectUrlShadowIt = errorCode === 403 && (0, $eMftW.getRedirectUrlFromShadowItError)(error);
    // Shadow IT unauthorized user redirects to adminhub's Shadow IT request flow.
    if (errorCode === 403 && Boolean(redirectUrlShadowIt)) window.location.assign(redirectUrlShadowIt);
};

});

parcelRegister("6isYE", function(module, exports) {
$parcel$export(module.exports, "getAdminPaymentLink", function () { return $2a79b28f6910d324$export$ee6f0e0498ee449; });

var $kNE9Z = parcelRequire("kNE9Z");
const $2a79b28f6910d324$export$ee6f0e0498ee449 = (error)=>{
    const errorResponse = error?.message?.trim();
    if (!errorResponse) return null;
    const errorBody = errorResponse.startsWith("Forbidden") ? errorResponse.substring(9).trim() : errorResponse;
    try {
        const paymentMethodsPath = JSON.parse(errorBody)?.paymentMethodsPath;
        if (!paymentMethodsPath) return null;
        const adminBaseUrl = (0, $kNE9Z.isProduction)() ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
        return adminBaseUrl + paymentMethodsPath;
    } catch  {
        return null;
    }
};
const $2a79b28f6910d324$export$fd042af660d8eb2d = (error)=>{
    const url = $2a79b28f6910d324$export$ee6f0e0498ee449(error);
    if (url) {
        window.open(url, "_blank");
        return {
            result: true,
            adminPaymentLink: url
        };
    }
    return {
        result: false
    };
};

});

parcelRegister("fgra6", function(module, exports) {
$parcel$export(module.exports, "SignupUFOLoggingActionTimeoutError", function () { return $56f15a525545281c$export$6a44d450a6df8fd1; });
$parcel$export(module.exports, "operateWithSignupUFOLogging", function () { return $56f15a525545281c$export$20e2df2ad005f6b6; });
$parcel$export(module.exports, "SignupGetUFOErrorType", function () { return $56f15a525545281c$export$aa2a0d3061506a46; });
$parcel$export(module.exports, "trackAndCompleteUFOEvent", function () { return $56f15a525545281c$export$480a57084d436f31; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $fuLgT = parcelRequire("fuLgT");

var $03EZb = parcelRequire("03EZb");

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");

var $gx3aw = parcelRequire("gx3aw");

var $lIWv2 = parcelRequire("lIWv2");
const { ABORTED: $56f15a525545281c$var$ABORTED } = (0, $lIWv2.UfoExperienceStatus);
const $56f15a525545281c$export$6a44d450a6df8fd1 = new Error(`Action times out`);
async function $56f15a525545281c$export$20e2df2ad005f6b6(options, callback, errorLogCallback, responseLogCallback) {
    const { interactionId: interactionId, interactionName: interactionName, type: type = "transition", timeout: timeout, labelStack: labelStack = [], errorContext: errorContext } = options;
    const baseStack = $56f15a525545281c$var$_buildUFOLoggerBaseStack();
    (0, $1BTY2.DefaultInteractionID).current = interactionId;
    (0, $a48Mt.addNewInteraction)(interactionId, interactionName, type, Date.now(), (0, $03EZb.getInteractionRate)(interactionName, type === "segment" ? "legacy" : type), labelStack);
    (0, $a48Mt.addCustomData)(interactionId, labelStack, baseStack);
    if (timeout) {
        const interaction = (0, $a48Mt.getActiveInteraction)();
        interaction?.changeTimeout(timeout);
    }
    try {
        const res = await callback();
        if (responseLogCallback) responseLogCallback(res);
        (0, $a48Mt.tryComplete)(interactionId, Date.now());
        return res;
    } catch (error) {
        if (errorLogCallback) {
            errorLogCallback(error);
            throw error;
        }
        const errorStack = $56f15a525545281c$var$_buildUFOLoggerErrorStack(error);
        const errorStackArray = Object.keys(errorStack).map((key)=>!!errorStack[key] ? {
                name: `${key}:${errorStack[key]}`
            } : null).filter((value)=>!!value);
        (0, $a48Mt.addError)(interactionId, interactionName, errorStackArray, $56f15a525545281c$export$aa2a0d3061506a46(error), `Error occurred on call: ${errorContext}`);
        (0, $a48Mt.abort)(interactionId, "unload");
        throw error;
    }
}
function $56f15a525545281c$export$88234b8f2fbbd263(options) {
    const { interactionName: interactionName, type: type, timeout: timeout, labelStack: labelStack } = options;
    const formSubmitInteractionId = (0, $fuLgT.default)();
    (0, $1BTY2.DefaultInteractionID).current = formSubmitInteractionId;
    (0, $a48Mt.addNewInteraction)(formSubmitInteractionId, interactionName, type, Date.now(), (0, $03EZb.getInteractionRate)(interactionName, type === "segment" ? "legacy" : type), labelStack ?? []);
    if (timeout) {
        const interaction = (0, $a48Mt.getActiveInteraction)();
        interaction?.changeTimeout(timeout);
    }
    return formSubmitInteractionId;
}
function $56f15a525545281c$export$fe5b9d161ae98d2f(options) {
    const { error: error, interactionId: interactionId, errorType: errorType, name: name, labelStack: labelStack, errorMessage: errorMessage, config: config } = options;
    const errorCode = error?.response?.status;
    if (errorCode) labelStack.push({
        name: `errorCode:${errorCode}`
    });
    const errorId = error?.response?.headers?.get("atl-traceid");
    if (errorId) labelStack.push({
        name: `atlTraceId:${errorId}`
    });
    const errorUrl = window?.location?.href;
    if (config.isQueryParamCheck && errorUrl) {
        const url = new URL(errorUrl);
        const requestUrl = error?.url;
        labelStack.push({
            name: `pathName:${url.pathname}`
        });
        if (requestUrl) labelStack.push({
            name: `requestPath:${new URL(requestUrl).pathname}`
        });
        const product = url.searchParams.get("product");
        if (product) labelStack.push({
            name: `product:${product}`
        });
        const edition = url.searchParams.get("edition");
        if (product) labelStack.push({
            name: `edition:${edition}`
        });
        const bundle = url.searchParams.get("bundle");
        if (product) labelStack.push({
            name: `bundle:${bundle}`
        });
    }
    (0, $a48Mt.addError)(interactionId, name, labelStack, errorType, errorMessage);
}
function $56f15a525545281c$export$b023879ae3e4fb7c(interactionId) {
    (0, $a48Mt.tryComplete)(interactionId, Date.now());
}
function $56f15a525545281c$export$a47c5df8850058(interactionId) {
    (0, $a48Mt.abort)(interactionId, "unload");
}
function $56f15a525545281c$export$aa2a0d3061506a46(error) {
    let errorType;
    if (error == $56f15a525545281c$export$6a44d450a6df8fd1) errorType = "timeout";
    else if (!!error?.response?.status) errorType = "http_exception";
    else if (error?.name) errorType = error.name;
    else errorType = "react_error";
    return errorType;
}
function $56f15a525545281c$export$480a57084d436f31(options) {
    const { experienceName: experienceName, experienceStatus: experienceStatus, interactionType: interactionType = "transition", ufoLogger: ufoLogger = [], error: error, errorName: errorName = "", errorMessage: errorMessage = "" } = options;
    const interactionId = (0, $fuLgT.default)();
    // UFO exposes 'labelStack', which acts similar to deferred info logger.
    // These logs surface to Splunk, but not SignalFX
    const labelStack = $56f15a525545281c$var$_buildUFOLoggerLabelStack({
        labelStack: ufoLogger,
        error: error
    });
    // Initialize UFO event
    (0, $a48Mt.addNewInteraction)(interactionId, experienceName, interactionType, Date.now(), (0, $03EZb.getInteractionRate)(experienceName, interactionType === "segment" ? "legacy" : interactionType), labelStack);
    if (experienceStatus === $56f15a525545281c$var$ABORTED) {
        // Add error meta data to UFO event
        (0, $a48Mt.addError)(interactionId, errorName, labelStack, $56f15a525545281c$export$aa2a0d3061506a46(error), errorMessage);
        // Send ABORTED event to UFO event queue
        (0, $a48Mt.abort)(interactionId, "unload");
    } else // Send SUCCEEDED event to UFO event queue
    (0, $a48Mt.tryComplete)(interactionId, Date.now());
}
function $56f15a525545281c$var$_buildUFOLoggerLabelStack(options) {
    const { labelStack: labelStack = [], error: error } = options;
    const baseStack = $56f15a525545281c$var$_buildUFOLoggerBaseStack();
    const errorStack = $56f15a525545281c$var$_buildUFOLoggerErrorStack(error);
    const baseStackArray = Object.keys(baseStack).map((key)=>!!baseStack[key] ? {
            name: `${key}:${baseStack[key]}`
        } : null).filter((value)=>!!value);
    const errorStackArray = Object.keys(errorStack).map((key)=>!!errorStack[key] ? {
            name: `${key}:${errorStack[key]}`
        } : null).filter((value)=>!!value);
    return [
        ...labelStack,
        ...baseStackArray ?? [],
        ...errorStackArray ?? []
    ];
}
function $56f15a525545281c$var$_buildUFOLoggerBaseStack() {
    // We want to use 'analyticsAnonymousId' to link the interaction to the user via Splunk logs
    const analyticsAnonymousId = (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id");
    // Build base stack for UFO logger
    const browserUrl = new URL(window?.location?.href);
    const browserPath = browserUrl?.pathname;
    const product = browserUrl.searchParams.get("product");
    const bundle = browserUrl.searchParams.get("bundle");
    const edition = browserUrl.searchParams.get("edition");
    return {
        anonymousId: analyticsAnonymousId,
        browserPath: browserPath,
        product: product,
        bundle: bundle,
        edition: edition
    };
}
function $56f15a525545281c$var$_buildUFOLoggerErrorStack(error) {
    // Build error stack if error present
    let errorUrl = null;
    let errorReqPath = null;
    let errorStatusCode = null;
    if (error) {
        if (error.url && typeof error.url === "string") try {
            errorUrl = new URL(error.url);
            errorReqPath = errorUrl ? new URL(errorUrl).pathname : undefined;
            errorStatusCode = error.response.status;
        } catch (e) {
            console.log("error building UFO error stack: ", e);
        }
    }
    return {
        errorReqPath: errorReqPath,
        errorCode: errorStatusCode
    };
}

});

parcelRegister("cURcB", function(module, exports) {
$parcel$export(module.exports, "ErrorType", function () { return $23d0e7cb9d3a9a7d$export$dba1278861bf0dc1; });
$parcel$export(module.exports, "useSiteNameValidation", function () { return $23d0e7cb9d3a9a7d$export$2bad1b70bce0c458; });

var $1oC0p = parcelRequire("1oC0p");

var $erWD3 = parcelRequire("erWD3");

var $eY3N6 = parcelRequire("eY3N6");

var $gPKCY = parcelRequire("gPKCY");

var $5Ntyw = parcelRequire("5Ntyw");
var $23d0e7cb9d3a9a7d$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["MAXIMUM_LENGTH"] = "maximumLength";
    ErrorType["INVALID_NAME"] = "invalidName";
    ErrorType["UNAVAILABLE"] = "unavailable";
    ErrorType["NETWORK_ERROR"] = "networkError";
    ErrorType["NO_ERROR"] = "noError";
    return ErrorType;
}({});
const $23d0e7cb9d3a9a7d$var$SITE_NAME_REGEX = /^[a-z0-9]+[a-z0-9-]+[a-z0-9]+$/;
function $23d0e7cb9d3a9a7d$export$2bad1b70bce0c458(siteName, onValidationChange = ()=>null) {
    const [isDirty, setIsDirty] = (0, $1oC0p.useState)(false);
    const [validation, setValidation] = (0, $1oC0p.useState)({
        isValid: undefined,
        error: "noError"
    });
    const [availability, setAvailable] = (0, $1oC0p.useState)({
        isValidating: false,
        isAvailable: false,
        error: "noError",
        siteName: ""
    });
    const [invalidTimes, setInvalidTimes] = (0, $1oC0p.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (siteName.length > 0 && !isDirty) setIsDirty(true);
        setAvailable({
            ...availability,
            isValidating: true
        });
        $23d0e7cb9d3a9a7d$var$validateSiteNameDebounced.cancel();
        if (!$23d0e7cb9d3a9a7d$var$validateSiteNameLength(siteName, setValidation, isDirty)) {
            setAvailable((availability)=>({
                    ...availability,
                    isValidating: false
                }));
            return;
        }
        (0, $gPKCY.ufoEventSiteNameAvailability).setCustomData({
            invalidTimes: invalidTimes
        });
        $23d0e7cb9d3a9a7d$var$validateSiteNameDebounced(siteName, stargateClient, setAvailable, availability, createAnalyticsEvent)?.catch(()=>{
            setAvailable({
                siteName: siteName,
                isAvailable: false,
                isValidating: false,
                error: "noError"
            });
        });
    }, [
        siteName
    ]);
    (0, $1oC0p.useEffect)(()=>{
        onValidationChange(!!validation.isValid && validation.error === "noError" && availability.isAvailable && siteName === availability.siteName && availability.error === "noError");
        if (validation.error === "invalidName") setInvalidTimes(invalidTimes + 1);
    }, [
        validation,
        availability
    ]);
    return {
        isValidating: availability.isValidating,
        isValid: validation.isValid && availability.isAvailable && siteName === availability.siteName,
        error: validation.error === "noError" ? availability.error : validation.error
    };
}
const $23d0e7cb9d3a9a7d$var$validateSiteNameLength = (siteName, setValidation, isDirty)=>{
    if (siteName.length === 0 && !isDirty) {
        setValidation({
            isValid: false,
            error: "noError"
        });
        return false;
    } else if (siteName.length < 3) {
        setValidation({
            isValid: false,
            error: "invalidName"
        });
        return false;
    } else if (siteName.length > 50) {
        setValidation({
            isValid: false,
            error: "maximumLength"
        });
        return false;
    } else if (!$23d0e7cb9d3a9a7d$var$SITE_NAME_REGEX.test(siteName)) {
        setValidation({
            isValid: false,
            error: "invalidName"
        });
        return false;
    }
    setValidation({
        isValid: true,
        error: "noError"
    });
    return true;
};
const $23d0e7cb9d3a9a7d$var$validateSiteNameDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($erWD3)))($23d0e7cb9d3a9a7d$var$validateSiteName, 300, {
    trailing: true
});
async function $23d0e7cb9d3a9a7d$var$validateSiteName(siteName, stargateClient, setAvailable, availability, createAnalyticsEvent) {
    setAvailable({
        ...availability,
        isValidating: true
    });
    try {
        (0, $gPKCY.ufoEventSiteNameAvailability).start({
            webPlatform: "bxp-ui"
        });
        const { availability: availability } = await stargateClient.checkCloudNameAvailability({
            cloudName: siteName
        });
        (0, $gPKCY.ufoEventSiteNameAvailability).success({
            customData: {
                siteName: siteName,
                availability: availability
            }
        });
        createAnalyticsEvent({
            isNewRelic: true,
            isAjax: true,
            apiName: "react-signup-site-validation",
            action: "react-signup-site-validation",
            success: true,
            response: {
                status: "200",
                apiUrl: "site-availability-url"
            }
        }).fire("signup");
        switch(availability){
            case "AVAILABLE":
                return setAvailable({
                    siteName: siteName,
                    isValidating: false,
                    isAvailable: true,
                    error: "noError"
                });
            default:
                return setAvailable({
                    siteName: siteName,
                    isValidating: false,
                    isAvailable: false,
                    error: "unavailable"
                });
        }
    } catch (e) {
        createAnalyticsEvent({
            isNewRelic: true,
            isAjax: true,
            apiName: "react-signup-site-validation",
            action: "react-signup-site-validation",
            success: false,
            response: undefined,
            additionalInfo: e
        }).fire("signup");
        return setAvailable({
            siteName: siteName,
            isValidating: false,
            isAvailable: false,
            error: "networkError"
        });
    }
}

});

parcelRegister("amfpH", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $e768825b373a6c77$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $e768825b373a6c77$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    timeout: {
        id: "siteActivation.nameSite.error.timeout",
        defaultMessage: "Something went wrong on our end. Please try again. If this keeps happening, <href-support>contact support</href-support>. (Issue ID for Atlassian use: {error_id})"
    },
    invalidName: {
        id: "siteActivation.nameSite.error.invalidName",
        defaultMessage: "Your site name must be at least 3 characters long. Use only lowercase letters and numbers."
    },
    maxLength: {
        id: "siteActivation.nameSite.error.maxLength",
        defaultMessage: "That's a bit too long \u2014 try something 50 characters or less."
    },
    unavailable: {
        id: "siteActivation.nameSite.error.unavailable",
        defaultMessage: "This site is already taken."
    },
    networkError: {
        id: "siteActivation.nameSite.error.networkError",
        defaultMessage: "Something went wrong. Please try again later."
    }
});

});


parcelRegister("jgBbG", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return $94f60ca190cbbbec$export$706672462bf25099; });

var $7VQPk = parcelRequire("7VQPk");

var $95d7u = parcelRequire("95d7u");
const $94f60ca190cbbbec$export$706672462bf25099 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95d7u.Content), {
        ...props
    });

});
parcelRegister("95d7u", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $636317ea5e3d75f8$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lX14w = parcelRequire("lX14w");

var $2WL8B = parcelRequire("2WL8B");

var $ff4S3 = parcelRequire("ff4S3");

var $eWKFr = parcelRequire("eWKFr");

var $33py5 = parcelRequire("33py5");

var $aw05g = parcelRequire("aw05g");

var $aMZEL = parcelRequire("aMZEL");

var $k3fT0 = parcelRequire("k3fT0");
const $636317ea5e3d75f8$export$7c6e2c02157bb7d2 = ({ SitePicker: SitePicker = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {}), SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aw05g.SiteToggleButton), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy })=>{
    const { showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker, activateSite: activateSite, sites: sites } = (0, $ff4S3.useSiteActivationContext)();
    const transactionSelectorEligible = (0, $2WL8B.useSignupTransactionSelectorCohort)();
    const sitePickerEnabled = sites.length > 0 && SitePicker && SiteToggleButton;
    // if the site picker is not enabled, let context know it is not showing
    (0, $1oC0p.useEffect)(()=>{
        if (!sitePickerEnabled && showSitePicker) setShowSitePicker(false);
    }, [
        sitePickerEnabled
    ]);
    const activateSiteWithPrivacyPolicy = ()=>{
        const privacyPolicy = document.getElementById("privacy-policy-text")?.innerHTML || "";
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k3fT0.ExistingSitesSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
    // Only show if user is in signup transaction selector cohort and creating a new site
    const showTxaSelector = !showSitePicker && transactionSelectorEligible;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                ...formProps,
                autoComplete: "off",
                "data-testid": "existing-sites-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            showSitePicker && sitePickerEnabled ? SitePicker : SiteNameInput,
                            sitePickerEnabled && SiteToggleButton
                        ]
                    }),
                    showTxaSelector && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aMZEL.TransactionAccountSelector), {}),
                    SubmitButton,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            })
    });
};
const $636317ea5e3d75f8$var$containerCss = null;

});
parcelRegister("eWKFr", function(module, exports) {
$parcel$export(module.exports, "SiteNameInput", function () { return $69669b99c9d478dc$export$42a3d109cf521241; });
/* site-name-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $cURcB = parcelRequire("cURcB");

var $kNE9Z = parcelRequire("kNE9Z");

var $iTHVN = parcelRequire("iTHVN");

var $kbpa7 = parcelRequire("kbpa7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $lbA31 = parcelRequire("lbA31");

var $ff4S3 = parcelRequire("ff4S3");

var $amfpH = parcelRequire("amfpH");

var $lJoGY = parcelRequire("lJoGY");

var $54KVk = parcelRequire("54KVk");
const $69669b99c9d478dc$export$42a3d109cf521241 = ({ inputLabel: inputLabel })=>{
    (0, $lbA31.useRecommendedSiteName)({
        onError: console.error
    }); // onError catches errors from endpoint
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, isSubmitting: isSubmitting, validationMessageState: [validationMessage, setValidationMessage], isValid: isValid, isValidating: isValidating, error: error, isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const siteNameAddressSuffix = (0, $kNE9Z.isProduction)() ? ".atlassian.net" : ".jira-dev.com";
    const visualFeedback = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).signupVisualAlignmentFeedback);
    (0, $1oC0p.useEffect)(()=>{
        switch(error){
            case (0, $cURcB.ErrorType).NO_ERROR:
                setValidationMessage(undefined);
                break;
            case (0, $cURcB.ErrorType).INVALID_NAME:
                setValidationMessage((0, $amfpH.messages).invalidName);
                break;
            case (0, $cURcB.ErrorType).MAXIMUM_LENGTH:
                setValidationMessage((0, $amfpH.messages).maxLength);
                break;
            case (0, $cURcB.ErrorType).UNAVAILABLE:
                setValidationMessage((0, $amfpH.messages).unavailable);
                break;
            case (0, $cURcB.ErrorType).NETWORK_ERROR:
                setValidationMessage((0, $amfpH.messages).networkError);
                break;
        }
    }, [
        error,
        setValidationMessage
    ]);
    const label = inputLabel ?? isWorkspaceProduct ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "siteActivation.yourWorkspace",
        defaultMessage: "Your workspace"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "accountActivation.nameSite.inputSiteNameLabel",
        defaultMessage: "Your site"
    });
    const ariaSuffixId = "site-name-suffix";
    const ariaHelperId = "site-name-helper";
    const ariaErrorId = "site-name-error";
    const [helperPresent, setHelperPresent] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        // Detect if helper text is rendered on the page to avoid invalid aria-describedby refs
        if (typeof document !== "undefined") setHelperPresent(!!document.getElementById(ariaHelperId));
    }, []);
    const textFieldAriaDescribedBy = [
        ariaSuffixId,
        helperPresent ? ariaHelperId : undefined,
        validationMessage ? ariaErrorId : undefined
    ].filter(Boolean).join(" ") || undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "adg4-site-name-input",
        className: (0, $2jatx.default)([
            "_17rn1kw7"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_11zt3784 _7hwb183y _1rwq3784 _r64ckb7n _1ljbkb7n _17eaf1ug _1heu1kw7 _125x1j6v _aljm1ch8 _5hv91osq _1mmsglyw",
                visualFeedback && "_7hwbtpi8"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                "aria-required": true,
                isDisabled: isSubmitting,
                name: "site-name",
                label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
                    children: label
                }),
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            isValid && "_olzhaf4m",
                            validationMessage !== undefined && "_olzh1wfy"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                type: "text",
                                autoComplete: "on",
                                testId: "site-name-input",
                                ...fieldProps,
                                value: siteName,
                                onChange: (e)=>{
                                    setSiteNameValue(e.currentTarget.value);
                                    fieldProps.onChange(e);
                                },
                                "aria-describedby": textFieldAriaDescribedBy,
                                elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_4cvr1h6o _1e0c1txw _y4ti19bv _w8l5gktf _1752gktf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            id: ariaSuffixId,
                                            className: (0, $2jatx.default)([
                                                "_syaz1rpy _1wyb8oy7 _y4tiu2gc _o5721q9c"
                                            ]),
                                            style: {
                                                "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
                                            },
                                            children: siteNameAddressSuffix
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJoGY.IsValidOrLoading), {
                                            isValidating: isValidating,
                                            siteNameValue: siteName,
                                            validationMessage: validationMessage
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                id: ariaErrorId,
                                role: "alert",
                                className: (0, $2jatx.default)([
                                    "_syaz1tmw _1wyboqnp _43ds17la _59381r31 _yha28stv _1nmznqa1",
                                    validationMessage && "_1pfhi2wt"
                                ]),
                                style: {
                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                },
                                children: validationMessage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...validationMessage
                                })
                            })
                        ]
                    })
            })
        })
    });
};
const $69669b99c9d478dc$var$inputInvalidCss = null;
const $69669b99c9d478dc$var$inputValidCss = null;
const $69669b99c9d478dc$var$fieldWrapperCss = null;
const $69669b99c9d478dc$var$fieldWrapperVisualFeedbackCss = null;
const $69669b99c9d478dc$var$labelCss = null;
const $69669b99c9d478dc$var$siteNameAfterCss = null;
const $69669b99c9d478dc$var$siteNameAfterLabelV2Css = null;
const $69669b99c9d478dc$var$siteNameErrorCss = null;
const $69669b99c9d478dc$var$siteNameErrorVisibleCss = null;

});
parcelRegister("lbA31", function(module, exports) {
$parcel$export(module.exports, "useRecommendedSiteName", function () { return $8bbeebdbf54863c8$export$c2aa7c9492b42e56; });

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");

var $3riD8 = parcelRequire("3riD8");

var $ff4S3 = parcelRequire("ff4S3");
function $8bbeebdbf54863c8$export$c2aa7c9492b42e56(props = {}) {
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, recommendedSiteName: recommendedSiteName } = (0, $ff4S3.useSiteActivationContext)();
    const [siteNamePopulated, setSiteNamePopulated] = (0, $1oC0p.useState)();
    const client = (0, $5Ntyw.useBxpWebStargateClient)();
    const user = (0, $3riD8.useLoggedInUser)();
    const email = user?.email;
    (0, $1oC0p.useEffect)(()=>{
        if (email) client.getRecommendedSiteName({
            email: email
        }).then((result)=>setSiteNameValue(result.recommendedName)).catch(props.onError);
    }, [
        client,
        email,
        props.onError,
        setSiteNameValue
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (siteNamePopulated) // take no action because site name was already changed via either user interaction or site-name recommendation
        return;
        if (siteName) // user has already started typing, let's not overwrite their input with a recommended site name
        setSiteNamePopulated(true);
        else if (recommendedSiteName) {
            setSiteNameValue(recommendedSiteName);
            setSiteNamePopulated(true);
        }
    }, [
        siteNamePopulated,
        recommendedSiteName,
        siteName,
        setSiteNameValue
    ]);
}

});

parcelRegister("lJoGY", function(module, exports) {
$parcel$export(module.exports, "IsValidOrLoading", function () { return $b4fede7ff554c6cb$export$71ec10810b978f7e; });

var $7VQPk = parcelRequire("7VQPk");

var $a9Umc = parcelRequire("a9Umc");

var $iUVnd = parcelRequire("iUVnd");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");
const $b4fede7ff554c6cb$export$71ec10810b978f7e = ({ isValidating: isValidating, siteNameValue: siteNameValue, validationMessage: validationMessage })=>{
    if (siteNameValue === "") return null;
    if (isValidating) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
        size: "small",
        testId: "spinner"
    });
    if (validationMessage) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUVnd))), {
        label: "warning",
        color: (0, $lP7A9.default)("color.icon.danger")
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a9Umc))), {
        label: "success",
        color: (0, $lP7A9.default)("color.icon.accent.lime")
    });
};

});

parcelRegister("54KVk", function(module, exports) {
$parcel$export(module.exports, "Label", function () { return $08e560f13c474cc2$export$b04be29aa201d4f5; });
/* label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $08e560f13c474cc2$var$labelCss = null;
const $08e560f13c474cc2$export$b04be29aa201d4f5 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _k48p4jg8 _vwz4gktf"
        ]),
        children: children
    });
};

});


parcelRegister("33py5", function(module, exports) {
$parcel$export(module.exports, "SitePicker", function () { return $b5507a35ec5b9046$export$7793ee10ee71ac54; });
/* site-picker.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $kbpa7 = parcelRequire("kbpa7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $ff4S3 = parcelRequire("ff4S3");

var $fMbfG = parcelRequire("fMbfG");

var $54KVk = parcelRequire("54KVk");
const $b5507a35ec5b9046$export$7793ee10ee71ac54 = ()=>{
    const { sites: sites, isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const label = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
        children: isWorkspaceProduct ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "siteActivation.yourWorkspace",
            defaultMessage: "Your workspace"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "siteActivation.siteNameSitePickerLabel",
            defaultMessage: "Your site"
        })
    });
    const visualFeedback = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).signupVisualAlignmentFeedback);
    if (sites.length === 1) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1mmsglyw _11ur183y _1rys1rga _a5o8xv17 _1tgt1kw7 _1cgv7vkz _1b7z1nn1 _jxt41kw7 _1f3hi2wt _nrq3ftgi _1npwi2wt _aszr7vkz",
            visualFeedback && "_11urtpi8"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            isDisabled: true,
            name: "site-picker-field",
            id: "site-picker-field",
            testId: "site-picker-field",
            label: label,
            defaultValue: sites[0]?.url.replace("https://", ""),
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                    ...fieldProps
                })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fMbfG.Dropdown), {
        sites: sites
    });
};
const $b5507a35ec5b9046$var$inputCss = null;
const $b5507a35ec5b9046$var$inputVisualFeedbackCss = null;

});
parcelRegister("fMbfG", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return $c66d8b790d64bccd$export$931cbfb6bfb85fc; });
/* dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $lAVaU = parcelRequire("lAVaU");

var $iTHVN = parcelRequire("iTHVN");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $ff4S3 = parcelRequire("ff4S3");
const $c66d8b790d64bccd$export$931cbfb6bfb85fc = ({ sites: sites })=>{
    const { sitePickerValue: sitePickerValue, setSitePickerValue: setSitePickerValue, isSubmitting: isSubmitting, isRequestInProgress: isRequestInProgress, isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const visualFeedback = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).signupVisualAlignmentFeedback);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "adg4-site-picker",
        className: (0, $2jatx.default)([
            "_125x1syg _62vcmccc _17rn1kw7 _1mmsglyw _pqyq183y _84yz183y _tnizyh40 _101oyh40 _9fwgmccc _1700grf3 _156ugrf3 _16z5grf3 _iazigrf3 _1ybr1crf _uy3o19bv",
            visualFeedback && "_pqyqtpi8 _84yztpi8"
        ]),
        style: {
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            defaultValue: sites[0],
            isDisabled: isSubmitting,
            id: "site-picker-field",
            name: "site-picker-field",
            testId: "site-picker-field",
            label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48p4jg8 _vwz4gktf"
                ]),
                children: isWorkspaceProduct ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "siteActivation.yourWorkspace",
                    defaultMessage: "Your workspace"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "WacSignupForm.siteNameN2ELabel",
                    defaultMessage: "Your site"
                })
            }),
            children: ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lAVaU.default), {
                    ...rest,
                    inputId: id,
                    options: sites,
                    getOptionLabel: (option)=>option.url.replace("https://", ""),
                    getOptionValue: (option)=>option.cloudId,
                    value: sitePickerValue,
                    onChange: (newValue)=>setSitePickerValue(newValue ?? sites[0]),
                    isLoading: isRequestInProgress,
                    isSearchable: false,
                    styles: {
                        menu: (base)=>({
                                ...base,
                                fontSize: (0, $iTHVN.fontSize).md
                            }),
                        container: (base)=>({
                                ...base,
                                fontFamily: "inherit"
                            }),
                        valueContainer: (base)=>({
                                ...base,
                                fontSize: (0, $iTHVN.fontSize).md,
                                minHeight: "40px",
                                paddingTop: "8px",
                                paddingRight: "6px",
                                paddingBottom: "8px",
                                paddingLeft: "6px"
                            }),
                        singleValue: (base)=>({
                                ...base,
                                margin: 0
                            })
                    }
                })
        })
    });
};
const $c66d8b790d64bccd$var$labelCss = null;
const $c66d8b790d64bccd$var$inputAndLabelStyles = null;
const $c66d8b790d64bccd$var$inputAndLabelVisualFeedbackCss = null;

});


parcelRegister("aw05g", function(module, exports) {
$parcel$export(module.exports, "SiteToggleButton", function () { return $b5b9071c4b1e6573$export$3bfd0ee4a8c5295a; });
/* site-toggle-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $ddxTX = parcelRequire("ddxTX");

var $iTHVN = parcelRequire("iTHVN");

var $ff4S3 = parcelRequire("ff4S3");
const $b5b9071c4b1e6573$export$3bfd0ee4a8c5295a = ()=>{
    const intl = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct, showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    const toggleYourSiteButtonText = showSitePicker ? isWorkspaceProduct ? intl.formatMessage({
        id: "siteActivation.nameSite.startNewWorkspaceButton",
        defaultMessage: "Start a new workspace"
    }) : intl.formatMessage({
        id: "siteActivation.nameSite.startNewSiteButton",
        defaultMessage: "Start a new site"
    }) : isWorkspaceProduct ? intl.formatMessage({
        id: "siteActivation.nameSite.useExistingWorkspaceButton",
        defaultMessage: "Use an existing workspace"
    }) : intl.formatMessage({
        id: "siteActivation.nameSite.useExistingSiteButton",
        defaultMessage: "Use an existing site"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
        appearance: "link",
        onClick: ()=>setShowSitePicker(!showSitePicker),
        className: (0, $2jatx.default)([
            "_18zrgrf3"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _1e0c1txw _1wyb8oy7 _zulp1y44 _syazrbzz"
            ]),
            style: {
                "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
            },
            children: [
                toggleYourSiteButtonText,
                /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    "aria-hidden": true,
                    fill: "currentColor",
                    height: "8",
                    width: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "m7.908 0-1.08 1.202 1.75 1.948H1.264C.842 3.15.5 3.53.5 4c0 .469.342.85.763.85H8.58l-1.75 1.948L7.907 8 11.5 4 7.908 0Z"
                    })
                })
            ]
        })
    });
};
const $b5b9071c4b1e6573$var$buttonCss = null;
const $b5b9071c4b1e6573$var$buttonInnerCss = null;

});

parcelRegister("aMZEL", function(module, exports) {
$parcel$export(module.exports, "TransactionAccountSelector", function () { return $cf45f2a2372e480a$export$24b383d12e62d81f; });
/* transaction-account-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $aTd7T = parcelRequire("aTd7T");

var $lAVaU = parcelRequire("lAVaU");

var $7GVWk = parcelRequire("7GVWk");

var $kbpa7 = parcelRequire("kbpa7");

var $ff4S3 = parcelRequire("ff4S3");

var $54KVk = parcelRequire("54KVk");
const $cf45f2a2372e480a$var$container = null;
const $cf45f2a2372e480a$export$24b383d12e62d81f = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $7GVWk.useUserContext)();
    const { isSubmitting: isSubmitting, selectedTransactionAccountId: selectedTransactionAccountId, setSelectedTransactionAccountId: setSelectedTransactionAccountId } = (0, $ff4S3.useSiteActivationContext)();
    const handleSelectionChange = (value)=>{
        if (value) setSelectedTransactionAccountId(value.value);
    };
    const selectedValue = transactionAccounts.find((account)=>account.id === selectedTransactionAccountId);
    const transactionAccountLabel = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "siteActivation.transactionAccountSelectorLabel",
        defaultMessage: "Billing Account"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "transaction-account-select-container",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpyh40"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTd7T.Label), {
                htmlFor: "transaction-account-select",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
                    children: transactionAccountLabel
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lAVaU.default), {
                inputId: "transaction-account-select",
                options: transactionAccounts.map((transactionAccount)=>({
                        label: transactionAccount.number,
                        value: transactionAccount.id
                    })),
                value: selectedValue ? {
                    label: selectedValue.number,
                    value: selectedValue.id
                } : null,
                onChange: handleSelectionChange,
                isDisabled: isSubmitting,
                isRequired: true,
                styles: {
                    control: (rest)=>({
                            ...rest,
                            borderRadius: "21px",
                            fontFamily: (0, $kbpa7.wacToken)("font.charlie.text"),
                            fontSize: "1rem",
                            padding: "0px 6px"
                        })
                }
            })
        ]
    });
};

});

parcelRegister("k3fT0", function(module, exports) {
$parcel$export(module.exports, "ExistingSitesSubmitButton", function () { return $01476f5b75cbd817$export$795867072991ebfa; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $01476f5b75cbd817$export$795867072991ebfa = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});
parcelRegister("8Mruz", function(module, exports) {
$parcel$export(module.exports, "SubmitButton", function () { return $b3ffdc0cbf384296$export$8b7b7cdfb85d78c5; });
/* submit-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lqyi6 = parcelRequire("lqyi6");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $ff4S3 = parcelRequire("ff4S3");
const $b3ffdc0cbf384296$export$8b7b7cdfb85d78c5 = ({ submitMessage: submitMessage })=>{
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted } = (0, $ff4S3.useSiteActivationContext)();
    const visualFeedback = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).signupVisualAlignmentFeedback);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted,
        isLoading: isSubmitting || hasSubmitted,
        className: (0, $2jatx.default)([
            "_ect41kw7 _1wyb7vkz _p12f1wug _1rjcftgi _1bsb1osq",
            visualFeedback && "_2rkoi2wt _1wybdlk8"
        ]),
        children: submitMessage
    });
};
const $b3ffdc0cbf384296$var$buttonCss = null;
const $b3ffdc0cbf384296$var$buttonVisualFeedbackCss = null;

});





parcelRegister("bs458", function(module, exports) {
$parcel$export(module.exports, "ReturnToProduct", function () { return $7a9446a5ace995a8$export$1cac7f8e3baae627; });
/* return-to-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $1ka2O = parcelRequire("1ka2O");

var $ff4S3 = parcelRequire("ff4S3");

var $jgBbG = parcelRequire("jgBbG");
const $7a9446a5ace995a8$export$1cac7f8e3baae627 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}), sites: sites })=>{
    const location = (0, $1ka2O.useLocation)();
    const createNewWorkspace = (0, $1oC0p.useMemo)(()=>{
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("createNew") === "true";
    }, [
        location.search
    ]);
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(createNewWorkspace);
    const { product: product } = (0, $7GVWk.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const sitesWithCurrentProduct = (0, $2WL8B.useSitesWithCurrentProduct)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const { user: { email: email } } = (0, $7GVWk.useUserContext)();
    const { productName: productName } = (0, $fcO7r.getProductData)(product?.key);
    if (sites === undefined) sites = sitesWithCurrentProduct;
    const visualFeedback = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).signupVisualAlignmentFeedback);
    const goToProductButtonText = isWorkspaceProduct ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>$7a9446a5ace995a8$var$createNewWorkspaceMessageLink(str, ()=>{
                setShowSiteNaming(true);
                createAnalyticsEvent({
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contactExpandGoToSiteNamingScreen",
                    attributes: {
                        productName: product?.name
                    }
                }).fire();
            })
    };
    const createNewWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: product?.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$7a9446a5ace995a8$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            ExistingUser,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                    className: (0, $2jatx.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $7a9446a5ace995a8$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "return-to-product",
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulp7vkz _1jop70sv _1bv01wug"
                        ]),
                        children: sites?.map((site, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                href: $7a9446a5ace995a8$var$getProductUrl({
                                    url: site.url,
                                    productKey: product?.key ?? ""
                                }),
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for event to fire
                                    createAnalyticsEvent({
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: "contactExpandClickReturnToProductButton",
                                        attributes: {
                                            productName: productName
                                        }
                                    }).fire();
                                    window.location.assign($7a9446a5ace995a8$var$getProductUrl({
                                        url: site.url,
                                        productKey: product?.key ?? ""
                                    }));
                                },
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _zulp19bv _yv0e1ghl _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                                ]),
                                style: {
                                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb7vkz _1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: productName
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1hap _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                                ]),
                                                style: {
                                                    "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                                },
                                                children: site.displayName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_p12fmgvx _13bo1kw7"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                            variant: "primary",
                                            size: "small",
                                            color: "blue",
                                            className: (0, $2jatx.default)([
                                                visualFeedback && "_2rkoi2wt _ect41kw7 _1wybwk7l"
                                            ]),
                                            children: goToProductButtonText
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $7a9446a5ace995a8$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l33gnd"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $7a9446a5ace995a8$var$createNewWorkspaceMessageLink = (str, exitView)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: exitView,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $7a9446a5ace995a8$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $gZgIU.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $7a9446a5ace995a8$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $fcO7r.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $fcO7r.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $7a9446a5ace995a8$var$containerCss = null;
const $7a9446a5ace995a8$var$goToExistingWorkspaceLinkCss = null;
const $7a9446a5ace995a8$var$goToExistingWorkspaceMessageCss = null;
const $7a9446a5ace995a8$var$switchAccountSubheader = null;
const $7a9446a5ace995a8$var$contentCss = null;
const $7a9446a5ace995a8$var$createNewWorkspaceMessageCss = null;
const $7a9446a5ace995a8$var$createNewWorkspaceLinkCss = null;
const $7a9446a5ace995a8$var$boxContainerCss = null;
const $7a9446a5ace995a8$var$siteBoxCss = null;
const $7a9446a5ace995a8$var$goToProductButtonCss = null;
const $7a9446a5ace995a8$var$buttonVisualFeedbackCss = null;
const $7a9446a5ace995a8$var$bold = null;
const $7a9446a5ace995a8$var$siteCss = null;
const $7a9446a5ace995a8$var$siteNameCss = null;
const $7a9446a5ace995a8$var$emailCss = null;
const $7a9446a5ace995a8$var$switchAccountLinkCss = null;

});

parcelRegister("ka4Xu", function(module, exports) {
$parcel$export(module.exports, "SiteActivation", function () { return $9dd5cc04ed0b1948$export$5f19f51fdf3d70; });
/* site-activation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2WL8B = parcelRequire("2WL8B");

var $ff4S3 = parcelRequire("ff4S3");

var $3fEYe = parcelRequire("3fEYe");
const $9dd5cc04ed0b1948$export$5f19f51fdf3d70 = (props)=>{
    const cohort = (0, $2WL8B.useCohort)(props.useContactExpandCohortLogic);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "site-activation",
        "data-cohort": cohort,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff4S3.SiteActivationContextProvider), {
            existingSites: props.existingSites,
            useContactExpandCohortLogic: props.useContactExpandCohortLogic,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3fEYe.SiteActivationSwitcher), {
                ...props
            })
        })
    });
};
// fill the available space in the parent container
const $9dd5cc04ed0b1948$var$siteActivationCss = null;

});
parcelRegister("3fEYe", function(module, exports) {
$parcel$export(module.exports, "SiteActivationSwitcher", function () { return $aeae241f769fd6ee$export$336514a242c2c5c0; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $jgBbG = parcelRequire("jgBbG");

var $jGkoX = parcelRequire("jGkoX");

var $lBvZp = parcelRequire("lBvZp");

var $2HR6E = parcelRequire("2HR6E");

var $3ptXA = parcelRequire("3ptXA");
const $aeae241f769fd6ee$export$336514a242c2c5c0 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}), ManagedUser: ManagedUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jGkoX.ManagedUser), {}), NewUser: NewUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lBvZp.NewUser), {}), WeekOneUser: WeekOneUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3ptXA.WeekOneUser), {}), UpgradeEligibleUser: UpgradeEligibleUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HR6E.UpgradeEligibleUser), {}), CurrentProductJoinableUser: CurrentProductJoinableUser, CurrentProductUser: CurrentProductUser, UpliftEligibleUser: UpliftEligibleUser, CrossflowEligibleUser: CrossflowEligibleUser, useContactExpandCohortLogic: useContactExpandCohortLogic })=>{
    const cohort = (0, $2WL8B.useCohort)(useContactExpandCohortLogic);
    if (cohort === (0, $2WL8B.COHORTS).MANAGED_USER && ManagedUser) return ManagedUser;
    if (cohort === (0, $2WL8B.COHORTS).WEEK_ONE_USER && WeekOneUser) return WeekOneUser;
    if (cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_JOINABLE_USER && CurrentProductJoinableUser) return CurrentProductJoinableUser;
    if (cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_USER && CurrentProductUser) return CurrentProductUser;
    if (cohort === (0, $2WL8B.COHORTS).NEW_USER && NewUser) return NewUser;
    if (cohort === (0, $2WL8B.COHORTS).UPGRADE_ELIGIBLE_USER && UpgradeEligibleUser) return UpgradeEligibleUser;
    if (cohort === (0, $2WL8B.COHORTS).UPLIFT_ELIGIBLE_USER && UpliftEligibleUser) return UpliftEligibleUser;
    if (cohort === (0, $2WL8B.COHORTS).CROSSFLOW_ELIGIBLE_USER && CrossflowEligibleUser) return CrossflowEligibleUser;
    return ExistingUser;
};

});
parcelRegister("jGkoX", function(module, exports) {
$parcel$export(module.exports, "ManagedUser", function () { return $0ef791acb9b8931b$export$fcb76302df2c072d; });
/* managed-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $izdHQ = parcelRequire("izdHQ");

var $jgBbG = parcelRequire("jgBbG");

var $3D1CY = parcelRequire("3D1CY");
const $0ef791acb9b8931b$export$fcb76302df2c072d = ()=>{
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const sites = (0, $2WL8B.useManagingOrgUserSites)();
    const { profile: profile, product: product } = (0, $7GVWk.useUserContext)();
    const orgId = profile?.attributes?.managingOrg?.orgId;
    const clickGoToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToReturnToProductScreen",
            attributes: {
                orgId: orgId,
                productName: product?.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$0ef791acb9b8931b$var$goToExistingWorkspace(str, clickGoToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    const clickGoToSiteNamingScreen = ()=>{
        setShowSiteNaming(true);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToSiteNamingScreen",
            attributes: {
                orgId: orgId,
                productName: product?.name
            }
        }).fire();
    };
    const goToSiteNamingMessageValues = {
        link: (str)=>$0ef791acb9b8931b$var$goToSiteNaming(str, clickGoToSiteNamingScreen)
    };
    const goToSiteNamingMessage = formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, goToSiteNamingMessageValues);
    return sites?.length ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "signup-guard-return-to-product",
        group: "treatment",
        metadata: {
            orgId: orgId
        },
        children: showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToExistingWorkspaceMessage
                })
            ]
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3D1CY.SitesList), {
                    sites: sites
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToSiteNamingMessage
                })
            ]
        })
    }) : null;
};
const $0ef791acb9b8931b$var$goToSiteNaming = (str, clickGoToSiteNamingScreen)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        onClick: clickGoToSiteNamingScreen,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $0ef791acb9b8931b$var$goToExistingWorkspace = (str, clickGoToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        onClick: clickGoToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $0ef791acb9b8931b$var$containerCss = null;
const $0ef791acb9b8931b$var$goToLinkCss = null;
const $0ef791acb9b8931b$var$goToMessageCss = null;

});
parcelRegister("3D1CY", function(module, exports) {
$parcel$export(module.exports, "SitesList", function () { return $fa618feefe0aa5d1$export$e2789664959efdd3; });
/* sites-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $kNE9Z = parcelRequire("kNE9Z");

var $iTHVN = parcelRequire("iTHVN");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $fa618feefe0aa5d1$export$e2789664959efdd3 = ({ sites: sites })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { profile: profile, product: product, user: { email: email } } = (0, $7GVWk.useUserContext)();
    const orgId = profile.attributes?.managingOrg?.orgId;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $fa618feefe0aa5d1$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c11p5 _1bsb1osq _1jc21k1x _1mbp1wug"
                ]),
                children: sites.map(({ displayName: displayName, url: url })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                        href: $fa618feefe0aa5d1$var$getIdentityUrl({
                            url: url,
                            productKey: product?.key
                        }),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "guardClickReturnToProductButton",
                                attributes: {
                                    orgId: orgId,
                                    productName: product?.name
                                }
                            }).fire();
                            window.location.href = $fa618feefe0aa5d1$var$getIdentityUrl({
                                url: url,
                                productKey: product?.key
                            });
                        },
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _179rj0fz _1e0c11p5 _zulp1y44 _yv0e9sye _1bah1yb4 _ca0q7vkz _u5f3ftgi _n3td7vkz _19bvftgi _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82 _8gg5glyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1syg"
                                ]),
                                style: {
                                    "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: product?.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1rpy _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wybdlk8"
                                        ]),
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_p12f13i4 _1e0c1txw _1bahesu3"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "secondary",
                                    size: "small",
                                    color: "black",
                                    className: (0, $2jatx.default)([
                                        "_ect41kw7 _1wybdlk8 _1rjcftgi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "bxpSignup.siteExpansion.goToProduct",
                                        defaultMessage: "Go to {productName}",
                                        values: {
                                            productName: product?.description
                                        }
                                    })
                                })
                            })
                        ]
                    }, url))
            })
        ]
    });
};
const $fa618feefe0aa5d1$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $gZgIU.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $fa618feefe0aa5d1$var$getIdentityUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $fcO7r.ProductKey).JIRA_SOFTWARE:
            return `${(0, $kNE9Z.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/jira`,
                application: "jira"
            })}`;
        case (0, $fcO7r.ProductKey).CONFLUENCE:
            return `${(0, $kNE9Z.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/wiki`,
                application: "confluence"
            })}`;
        case (0, $fcO7r.ProductKey).DEVAI:
            return `${(0, $kNE9Z.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/rovodev`,
                application: "devai"
            })}`;
        default:
            return url;
    }
};
const $fa618feefe0aa5d1$var$containerCss = null;
const $fa618feefe0aa5d1$var$switchAccountSubheader = null;
const $fa618feefe0aa5d1$var$sitesListCss = null;
const $fa618feefe0aa5d1$var$siteBoxCss = null;
const $fa618feefe0aa5d1$var$productNameCss = null;
const $fa618feefe0aa5d1$var$siteCss = null;
const $fa618feefe0aa5d1$var$siteNameCss = null;
const $fa618feefe0aa5d1$var$goToSiteButtonContainerCss = null;
const $fa618feefe0aa5d1$var$goToSiteButtonCss = null;
const $fa618feefe0aa5d1$var$emailCss = null;
const $fa618feefe0aa5d1$var$switchAccountLinkCss = null;

});


parcelRegister("lBvZp", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return $642e4e985a9cdc5c$export$17cbb676e2e98676; });

var $7VQPk = parcelRequire("7VQPk");

var $3kezV = parcelRequire("3kezV");
const $642e4e985a9cdc5c$export$17cbb676e2e98676 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3kezV.Content), {
        ...props
    });

});
parcelRegister("3kezV", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $3dbd49b2429de188$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lX14w = parcelRequire("lX14w");

var $ff4S3 = parcelRequire("ff4S3");

var $eWKFr = parcelRequire("eWKFr");

var $3naW4 = parcelRequire("3naW4");

var $8SDzo = parcelRequire("8SDzo");
const $3dbd49b2429de188$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), HelperText: HelperText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3naW4.HelperText), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy = null })=>{
    const { activateSite: activateSite } = (0, $ff4S3.useSiteActivationContext)();
    const activateSiteWithPrivacyPolicy = ()=>{
        const privacyPolicy = document.getElementById("privacy-policy-text")?.innerHTML || "";
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8SDzo.NewUserSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                ...formProps,
                autoComplete: "off",
                "data-testid": "new-user-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            SiteNameInput,
                            HelperText
                        ]
                    }),
                    SubmitButton,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            })
    });
};
const $3dbd49b2429de188$var$containerCss = null;

});
parcelRegister("3naW4", function(module, exports) {
$parcel$export(module.exports, "HelperText", function () { return $b38a10467ddc3e98$export$7bc3de131d90901c; });
/* helper-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ff4S3 = parcelRequire("ff4S3");

var $8e22h = parcelRequire("8e22h");
const $b38a10467ddc3e98$export$7bc3de131d90901c = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const text = isWorkspaceProduct ? formatMessage({
        id: "siteActivation.nameSite.inputWorkspaceNameHelperText",
        defaultMessage: "This workspace name is just a suggestion. Feel free to change to something your team will recognize."
    }) : formatMessage({
        id: "siteActivation.nameSite.inputSiteNameHelperText",
        defaultMessage: "This site name is just a suggestion. Feel free to change to something your team will recognize."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        id: "site-name-helper",
        className: (0, $2jatx.default)([
            "_syaz1kw7 _1wyboqnp _vwz4bs82 _19pk1kwk _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: text
    });
};
const $b38a10467ddc3e98$var$helperTextCss = null;

});

parcelRegister("8SDzo", function(module, exports) {
$parcel$export(module.exports, "NewUserSubmitButton", function () { return $95b46875f4877d38$export$f05369598c89e38f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $95b46875f4877d38$export$f05369598c89e38f = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});



parcelRegister("2HR6E", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return $ce270ebdae685cc4$export$31213096ab10a3ce; });

var $7VQPk = parcelRequire("7VQPk");

var $b72iB = parcelRequire("b72iB");
const $ce270ebdae685cc4$export$31213096ab10a3ce = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $b72iB.Content), {
        ...props
    });

});
parcelRegister("b72iB", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $455b4be8f401193e$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $aw05g = parcelRequire("aw05g");

var $33py5 = parcelRequire("33py5");

var $eWKFr = parcelRequire("eWKFr");

var $lX14w = parcelRequire("lX14w");

var $ff4S3 = parcelRequire("ff4S3");

var $ejUcs = parcelRequire("ejUcs");
const $455b4be8f401193e$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), SitePicker: SitePicker = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aw05g.SiteToggleButton), {}), SubmitButton: SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ejUcs.UpgradeEligibleSubmitButton), {}) })=>{
    const { activateSite: activateSite, showSitePicker: showSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSite,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                ...formProps,
                autoComplete: "off",
                "data-testid": "upgrade-eligible-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            showSitePicker ? SitePicker : SiteNameInput,
                            SiteToggleButton
                        ]
                    }),
                    SubmitButton
                ]
            })
    });
};
const $455b4be8f401193e$var$containerCss = null;

});
parcelRegister("ejUcs", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleSubmitButton", function () { return $ec48f630e3d05de6$export$9143452c910a3be3; });

var $7VQPk = parcelRequire("7VQPk");

var $ff4S3 = parcelRequire("ff4S3");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $ec48f630e3d05de6$export$9143452c910a3be3 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { showSitePicker: showSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    const submitMessage = showSitePicker ? formatMessage({
        id: "WacSignupForm.upgradeButtonText",
        defaultMessage: "Upgrade now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});



parcelRegister("3ptXA", function(module, exports) {
$parcel$export(module.exports, "WeekOneUser", function () { return $0d9840caf41bd814$export$16be3dbbc731576d; });
/* week-one-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lmQGF = parcelRequire("lmQGF");

var $fcO7r = parcelRequire("fcO7r");

var $7GVWk = parcelRequire("7GVWk");

var $kbpa7 = parcelRequire("kbpa7");

var $jgBbG = parcelRequire("jgBbG");

var $g4osg = parcelRequire("g4osg");
const $0d9840caf41bd814$export$16be3dbbc731576d = ()=>{
    const createNewWorkspace = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === "undefined") return false;
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get("createNew") === "true";
    }, []);
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(createNewWorkspace);
    const { product: product } = (0, $7GVWk.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: product?.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$0d9840caf41bd814$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = product?.key === (0, $fcO7r.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g4osg.ReturnToExistingProduct), {
        productKeyForExpand: product?.key || (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
        exitView: ()=>{
            setShowSiteNaming(true);
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "contactExpandGoToSiteNamingScreen",
                attributes: {
                    productName: product?.name
                }
            }).fire();
        }
    });
};
const $0d9840caf41bd814$var$containerCss = null;
const $0d9840caf41bd814$var$goToExistingWorkspaceLinkCss = null;
const $0d9840caf41bd814$var$goToExistingWorkspaceMessageCss = null;
const $0d9840caf41bd814$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3l3k2"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: str
    });

});
parcelRegister("g4osg", function(module, exports) {
$parcel$export(module.exports, "ReturnToExistingProduct", function () { return $a961e78bb1453a70$export$ba7c22a9ce02f49f; });
/* return-to-existing-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lmQGF = parcelRequire("lmQGF");

var $iTHVN = parcelRequire("iTHVN");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $a961e78bb1453a70$export$ba7c22a9ce02f49f = ({ exitView: exitView, productKeyForExpand: productKeyForExpand })=>{
    const d0to6JiraSite = (0, $2WL8B.useProductD0to6Site)({
        productKey: productKeyForExpand
    });
    const { product: product } = (0, $7GVWk.useUserContext)();
    const { user: { email: email } } = (0, $7GVWk.useUserContext)();
    const { productName: productName } = (0, $fcO7r.getProductData)(product?.key);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const goToProductButtonText = productKeyForExpand === (0, $fcO7r.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                onClick: exitView,
                className: (0, $2jatx.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const createNewWorkspaceMessage = productKeyForExpand === (0, $fcO7r.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    return !d0to6JiraSite ? null : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect41kw7 _1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                    className: (0, $2jatx.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $a961e78bb1453a70$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "return-to-existing-product",
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq"
                        ]),
                        style: {
                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                            href: $a961e78bb1453a70$var$getProductUrl({
                                url: d0to6JiraSite.url,
                                productKey: product?.key ?? ""
                            }),
                            onClick: (e)=>{
                                e.preventDefault(); // wait for event to fire
                                createAnalyticsEvent({
                                    eventType: "ui",
                                    action: "clicked",
                                    actionSubject: "button",
                                    actionSubjectId: "contactExpandClickReturnToProductButton",
                                    attributes: {
                                        productName: productName
                                    }
                                }).fire();
                                window.location.href = $a961e78bb1453a70$var$getProductUrl({
                                    url: d0to6JiraSite.url,
                                    productKey: product?.key ?? ""
                                });
                            },
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1yb4 _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1wyb1syg _1reo15vq _18m915vq"
                                    ]),
                                    style: {
                                        "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                            ]),
                                            children: productName
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_syaz1hap _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                            ]),
                                            style: {
                                                "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                            },
                                            children: d0to6JiraSite.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    className: (0, $2jatx.default)([
                                        "_ect41kw7 _1wyb7vkz _1rjcftgi"
                                    ]),
                                    children: goToProductButtonText
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $a961e78bb1453a70$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $gZgIU.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $a961e78bb1453a70$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $fcO7r.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $fcO7r.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $a961e78bb1453a70$var$switchAccountSubheader = null;
const $a961e78bb1453a70$var$containerCss = null;
const $a961e78bb1453a70$var$contentCss = null;
const $a961e78bb1453a70$var$createNewWorkspaceMessageCss = null;
const $a961e78bb1453a70$var$createNewWorkspaceLinkCss = null;
const $a961e78bb1453a70$var$boxContainerCss = null;
const $a961e78bb1453a70$var$siteBoxCss = null;
const $a961e78bb1453a70$var$bold = null;
const $a961e78bb1453a70$var$siteCss = null;
const $a961e78bb1453a70$var$siteNameCss = null;
const $a961e78bb1453a70$var$emailCss = null;
const $a961e78bb1453a70$var$switchAccountLinkCss = null;
const $a961e78bb1453a70$var$goToProductButtonCss = null;

});





//# sourceMappingURL=confluence-software-anchor-lp-automation.bd91385e.js.map
